import { render, staticRenderFns } from "./section-container.vue?vue&type=template&id=3b2d8860&scoped=true&"
import script from "./section-container.vue?vue&type=script&lang=js&"
export * from "./section-container.vue?vue&type=script&lang=js&"
import style0 from "./section-container.vue?vue&type=style&index=0&id=3b2d8860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2d8860",
  null
  
)

export default component.exports